import { gateway } from "../../gateway";

export const getCurrentCompanyAction = async (activeCompanyId: number | string) => {
  const res = await gateway.get("/companies/self");

  const companies = res?.data?.data ?? [];

  const membership = companies.find((item: any) => String(item.companyId) === String(activeCompanyId));

  if (!membership?.company) {
    return null;
  }

  return {
    ...membership.company,
    coverageAreas: membership.company.coverageAreas ?? [],
    role: membership.userRole?.role,
  };
};
